import { StreemAPI } from '@streem/api';
import { invariant } from '@streem/toolbox';
import { logger } from '../../util/logger';
export class HostController {
    constructor(config) {
        this.config = config;
    }
    async getHostUserCallLog() {
        invariant(this.config.context.remoteUserId, 'Expected remoteUserId to be defined when retrieving call details');
        // We constrain the call log to the last 10 calls but this can be changed if needed
        try {
            const PAGE_SIZE = 10;
            const callEntryDetails = await StreemAPI.users.getUserCallLog(this.config.context.remoteUserId.toString(), PAGE_SIZE);
            return callEntryDetails.callLogEntries;
        }
        catch (error) {
            logger.error('Error retrieving call log details', error);
        }
    }
}
//# sourceMappingURL=host_controller.js.map